module.exports = __webpack_public_path__ + "static/simorq_logo_vector_final_main-64b9aefc90eba3ae47e892ee2af7510d.svg";